<template>
    <div>
        <v-main>
            <akcd_overview/>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata" />
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    import akcd_overview from '@/components/syst/ref/akcd/akcd_overview.vue'

    export default {
        components: {
            navBar,
            akcd_overview,
        },    
        data() {
            return {
            }
        },    
        methods: {     
        }
    }
</script>

<style scoped> 

</style>